import { useNavigate } from "react-router-dom";
import GridView from "../../components/controls/GridView/GridView";
import creditOfficerService from "../../services/creditOfficerService";
import { useEffect, useState } from "react";
import SearchBar from "../../components/controls/SearchBar/SearchBar";
import FormModal from "../../components/controls/FormModal/FormModal";
import FormCommand from "../../components/controls/FormCommand";
import { MenuItem } from "../../models/menu";
import { CreditOfficer } from "../../models/interfaces";
import Frame from "../../components/controls/Frame/Frame";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";
import { MdDelete, MdEdit } from "react-icons/md";

export interface CreditOfficersListingPageProps {
  isModal?: false;
}

export const CreditOfficersListingPage = (
  props: CreditOfficersListingPageProps
) => {
  const navigate = useNavigate();
  const [creditOfficers, setCreditOfficers] = useState<CreditOfficer[]>();
  const [officer, setOfficer] = useState<CreditOfficer>();

  const getOfficers = async (search: string = "") => {
    const res = await creditOfficerService.getCreditOfficers({
      name: search,
    });

    if (res.status) {
      setCreditOfficers(res.data ?? []);
    }
  };

  useEffect(() => {
    getOfficers();
  }, [creditOfficers]);

  function getCreditOfficerContextMenu(): MenuItem<CreditOfficer>[] {
    return [
      {
        name: "Edit",
        onClick: (d) => setOfficer(d),
        icon: <MdEdit />,
      },
      {
        name: "Delete",
        onClick: (d) => {
          creditOfficerService.deleteCreditOfficer(d.id ?? 0).then((res) => {
            if (res.status) {
              setCreditOfficers(creditOfficers?.filter((s) => s.id != d.id));
            }
          });
        },
        icon: <MdDelete />,
      },
    ];
  }

  const saveCreditOfficer = async () => {
    const res = await creditOfficerService.addOrUpdateCreditOfficer({
      name: officer?.name ?? "",
    });

    alert(res.message);

    if (res.status && creditOfficers !== undefined) {
      setCreditOfficers([...creditOfficers, res.data as CreditOfficer]);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <h4>Credit Officers</h4>
            <GridView
              keys={["name"]}
              name={"lstTransactions"}
              context="Credit Officers"
              showSearchBar={true}
              showAddButton={true}
              onAddRecord={() => setOfficer({})}
            >
              <GridView.Header>
                <tr>
                  <th>Credit Officer Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </GridView.Header>
              <GridView.Content>
                {creditOfficers?.map((d) => (
                  <tr>
                    <td>{d.name}</td>
                    <td>{d.phone}</td>
                    <td>{d.email}</td>
                    <td>
                      <ContextMenu
                        item={d}
                        menu={getCreditOfficerContextMenu()}
                      />
                    </td>
                  </tr>
                ))}
              </GridView.Content>
            </GridView>
          </Frame>
        </div>
      </div>

      {officer && (
        <FormModal onClose={() => setOfficer(undefined)}>
          <div className="row">
            <div className="col">
              <div className="form-group">
                <label htmlFor="name" className="control-label">
                  Credit Officer Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  className="form-control form-control-sm"
                  required
                  value={officer.name}
                  placeholder="Enter name of the credit officer"
                  onChange={(e) =>
                    setOfficer({ ...officer, name: e.currentTarget.value })
                  }
                />
              </div>

              <FormCommand
                onSubmit={() => {
                  saveCreditOfficer();
                }}
              />
            </div>
          </div>
        </FormModal>
      )}
    </>
  );
};
